import { Pipe, PipeTransform } from '@angular/core';
import { Assignment, ASSIGNMENT_TYPE, FindOne } from '@univacity/shared/types';
import { Observable } from 'rxjs';
import { AssignmentService } from '../services';

@Pipe({
  name: 'assignment',
  standalone: false,
})
export class AssignmentPipe implements PipeTransform {
  constructor(private assignmentService: AssignmentService) {}

  transform(
    applicationId: string,
    type: ASSIGNMENT_TYPE,
    query: FindOne
  ): Observable<Assignment> {
    return this.assignmentService.findOneByReference(
      applicationId,
      type,
      query
    );
  }
}
